import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { TaggedLogger } from './taggedLogger';
import { toLower } from 'lodash';

/**
 * Envrionment service,
 * lets us know what environment we're running on at runtime.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private readonly logger: TaggedLogger;
  private readonly environmentRegex = /(.*?)\.engineius\.co\.uk/i;
  private readonly fodEnvironmentRegex = /([0-9]*)\.engineius\.io/i;
  private readonly prodSubdomain = 'portal';
  private readonly saasProdHost = 'app.engynn.co.uk';

  private checked = false;
  private environment = '';

  constructor(loggerService: LoggerService) {
    this.logger = loggerService.taggedLogger('service:environment');
  }

  /**
   * Gets the current environment's name
   *
   * Returns empty string for unknown environments
   *
   * @return the environment name or an empty string
   */
  getName() {
    if (this.checked) return this.environment;

    const { host } = window.location;

    this.logger.debug('Environment:', this.environment);
    this.checked = true;
    this.environment = this.getEnvironmentFromHostName(host);
    return this.environment.replace('engineius-', '');
  }

  isProduction() {
    const name = this.getName();
    return name === 'portal' || this.isSaasProdHost();
  }

  isBeta() {
    const name = this.getName();
    return name === 'portal-beta';
  }

  isSandboxOrUAT() {
    const name = this.getName();
    return name === 'engineius-sandbox' || name === 'engineius-uat';
  }

  isUnknown() {
    return !this.getName();
  }

  private isSaasProdHost() {
    return window.location.hostname.toLowerCase() === this.saasProdHost;
  }

  private getEnvironmentFromHostName(hostName: string) {
    if (!hostName) return '';

    if (!this.environmentRegex.test(hostName)) return '';

    let matches = this.environmentRegex.exec(hostName);

    if (matches && matches[1]) {
      return toLower(matches[1]);
    }

    matches = this.fodEnvironmentRegex.exec(hostName);

    if (matches) {
      return 'FOD';
    }

    return '';
  }
}
